// extracted by mini-css-extract-plugin
module.exports = {"usp":"ProductUSP_usp__PiCJ3","uspItem":"ProductUSP_uspItem__IFzkO"};